import { render } from "./EditGpsCamera.vue?vue&type=template&id=6b573f25"
import script from "./EditGpsCamera.vue?vue&type=script&lang=js"
export * from "./EditGpsCamera.vue?vue&type=script&lang=js"
script.render = render

export default script